<template>
  <main class="role-wrapper">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
      style="width:335px"
    >
      <el-form-item label="角色名称" prop="roleName">
        <el-input
          v-model="form.roleName"
          placeholder="请输入角色名称"
          :disabled="type === 'check'"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色权限" prop="resources">
        <el-tree
          :data="data.length ? data : auth.allAuth"
          :show-checkbox="showCheckBox"
          :default-expand-all="type === 'check' ? true : false"
          node-key="resourceCode"
          :default-checked-keys="checkedKeys"
          :default-expanded-keys="checkedKeys"
          ref="tree"
          highlight-current
          @check="selected"
          :props="defaultProps"
        >
        </el-tree>
      </el-form-item>
    </el-form>
  </main>
</template>

<script>
import eventBus from '../../../utils/fresh-table'
export default {
  created() {
    if (this.type === 'edit') {
      this.getCheckedArray(this.auth.editAuthDetail)
    }
    this.form.roleName = this.type === 'create' ? '' : this.role.roleName
    if (this.type === 'check') {
      this.data = this.auth.checkHaveAuth
    } else if (this.type === 'create') {
      this.$store.dispatch('auth/get_ALL_AUTH') // 获取所有权限
    } else {
      this.data = this.auth.editAuthDetail
    }
  },
  data() {
    return {
      form: {
        roleName: '',
        resources: [],
      },
      data: [],
      checkedKeys: [],
      defaultProps: {
        children: 'childResource',
        label: 'name',
      },
      rules: {
        roleName: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' },
          { max: 10, message: '最长为10个汉字', trigger: 'blur' },
        ],
        resources: [
          { required: true, message: '角色权限不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  props: {
    expandAll: {
      type: Boolean,
      default() {
        return true
      },
    },
    showCheckBox: {
      type: Boolean,
    },
    role: {
      type: Object,
    },
    type: {
      type: String,
    },
  },
  computed: {
    auth() {
      return this.$store.state.auth
    },
  },
  methods: {
    getCheckedArray(arr) {
      for (const temp of arr) {
        if (temp.checked && temp.parentCode != '') {
          this.checkedKeys.push(temp.resourceCode)
        }
        if (temp.childResource && temp.childResource.length > 0) {
          this.getCheckedArray(temp.childResource)
        } else {
          if (temp.checked) {
            this.checkedKeys.push(temp.resourceCode)
          }
        }
      }
      this.form.resources = this.checkedKeys
    },
    selected() {
      this.form.resources = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys())
    },
    submitForm(form) {
      const url =
        this.type === 'edit' ? '/proxy/auth/role/edit' : '/proxy/auth/role/add'
      let data = {
        ...this.form,
      }
      if (this.type === 'edit') {
        // 新增
        data = Object.assign({}, data, {
          roleCode: this.role.roleCode,
        })
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$request({
            url: url,
            method: 'post',
            data: data,
          }).then((res) => {
            if (!res.errorCode) {
              if (this.type === 'edit') {
                this.$message('角色信息已保存')
                eventBus.$emit('freshTable')
                this.$store.commit('auth/update', {
                  isShowDialog: false,
                })
              } else {
                this.$message({
                  message: '已成功添加新角色',
                  type: 'success',
                })
                this.$router.push({
                  path: '/console/user-manage/user-auth',
                })
              }
            }
          })
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="stylus">
.role-wrapper
  .el-tree
    margin-top 8px
    margin-bottom 12px
  .el-form-item__label
    text-align left
</style>
